/* eslint-disable no-empty */
import {
  doPostCartItem,
  doPostSessionCartItem,
  doFetchQuote,
  doFetchCartProducts,
  doFetchTotalAmt,
  doDeleteCartProduct,
  doPutCartItem,
  doPutMiniCartItem,
  // doFetchCartId,
  doPutGiftCartItem,
  doPutConfiguredCartItem,
  doPostConfiguredCartItem,
  doQtyUpdateCartItem,
  convertGuestToCustomerCart,
  doUpdateCCProductQuantity
  // doPostGiftCartItem
} from "@/services/user_cart.service";
import {
  getProductOptionByType,
  isStrictNonZeroDecimal
} from "@/services/util.service";
import { doFetchList } from "@/services/session_item.service";
import { doFetchByDesignProjectId } from "@/services/session.service";

import { getCookieByName, removeCookieByName } from "@/services/auth";
import { getField, updateField } from "vuex-map-fields";
import humps from "lodash-humps";
import { getAuthUser } from "@/services/auth";
const crGuestQuoteId = import.meta.env.VITE_APP_GUEST_QUOTE_ID;
import {
  criteoViewBasket,
  listrakCartList,
  listrakCartListClear
} from "@/services/util.service";
/* eslint-disable no-alert, no-console ,   */
export const userCartProduct = {
  namespaced: true,
  state: {
    cartDrawer: false,
    inProgress: false,
    fetchInProgress: false,
    cartProduct: [],
    cartProductList: [],
    productTotalAmt: [],
    productMedia: {},
    errorMessage: null,
    cartProductsProgress: false,
    cartTotalAmtProgress: false,
    cartProductDetails: [],
    giftCartDetails: {
      // "senderName": "",
      // "senderEmail": "",
      recipientName: "",
      recipientEmail: "",
      senderMessage: "",
      //"giftCardQty": "",
      giftCardAmt: ""
    },
    autoLogoutFlag: false,
    userQuoteId: null
  },
  getters: {
    getField
  },
  mutations: {
    updateField,

    inProgress(state, yesOrNo) {
      state.inProgress = yesOrNo;
    },
    cartProductsProgress(state, yesOrNo) {
      state.cartProductsProgress = yesOrNo;
    },
    cartTotalAmtProgress(state, yesOrNo) {
      state.cartTotalAmtProgress = yesOrNo;
    },
    setCartDrawer(state, yesOrNo) {
      state.cartDrawer = yesOrNo;
    },
    fetchInProgress(state, yesOrNo) {
      state.fetchInProgress = yesOrNo;
    },
    setCartProduct(state, product) {
      state.cartProduct = product;
    },
    setCartProductList(state, list) {
      state.cartProductList = list;
    },
    setCartProductDetails(state, details) {
      state.cartProductDetails = details;
    },
    setProductAmt(state, amt) {
      state.productTotalAmt = amt;
    },
    setErrorMessage(state, err) {
      state.errorMessage = err;
    },
    setProductsMedia(state, media) {
      state.productMedia = media;
    },
    setAutoLogoutFlag(state, flag) {
      state.autoLogoutFlag = flag;
    },
    setUserQuoteId(state, quote) {
      state.userQuoteId = quote;
    },
    setListrakCartListClear() {
      listrakCartListClear();
    },
    setCriteoViewBasket(state) {
      criteoViewBasket(state.cartProductList);
    },
    setListrakCartList(state) {
      listrakCartList(state.cartProductList);
    },
    updateCartItem(state, { index, data }) {
      state.cartProductList[index] = {
        ...state.cartProductList[index],
        ...data
      };
    }
  },
  actions: {
    fetchUserQuote: async ({ commit }) => {
      commit("inProgress", true);
      const userQuote = await doFetchQuote();
      if (userQuote) {
        commit("setUserQuoteId", userQuote);
        commit("inProgress", false);
        return userQuote;
      }
      commit("inProgress", false);
      return null;
    },
    addSessionProductToCart: async (
      { commit },
      { sku, qty, enteredOptions }
    ) => {
      try {
        commit("inProgress", true);
        let cartProduct = null;

        const userQuote = await doFetchQuote();
        localStorage.setItem("cr_userQuoteId", userQuote); //no use
        cartProduct = await doPostSessionCartItem({
          sku,
          qty,
          userQuote,
          enteredOptions
        }); // builderId,

        commit("inProgress", false);
        // commit('setCartDrawer', true);
        return cartProduct;
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },

    productTotalAmt: async ({ commit }) => {
      commit("cartTotalAmtProgress", true);
      doFetchTotalAmt()
        .then((productTotalAmt) => {
          commit("cartTotalAmtProgress", false);
          commit("setProductAmt", humps(productTotalAmt));
        })
        .catch(() => commit("cartTotalAmtProgress", false));
    },
    cartProductList: async (
      { commit, rootState, dispatch },
      builderSessionId
    ) => {
      commit("setCartProductList", []);
      commit("cartProductsProgress", true);
      try {
        const quoteId = await doFetchQuote();
        let guestQuoteId = await getCookieByName(crGuestQuoteId);
        if (guestQuoteId) {
          try {
            await convertGuestToCustomerCart({
              guestCartId: guestQuoteId,
              customerCartId: quoteId,
            });
            removeCookieByName(crGuestQuoteId);
          } catch (error) { }

          let cartProductList = await doFetchCartProducts(quoteId);
          commit("setCartProductDetails", humps(cartProductList));
          commit("setCartProductList", humps(cartProductList));
          commit("cartProductsProgress", false);
          dispatch("productTotalAmt");
          return humps(cartProductList);
        } else {
          let cartProductList = await doFetchCartProducts(quoteId);

          //let newCartProductList=[];
          if (cartProductList.length > 0) {
            for (let i = 0; i < cartProductList.length; i++) {
              if (
                cartProductList[i] &&
                cartProductList[i].options &&
                cartProductList[i].options.options
              ) {
                let optionsList = cartProductList[i].options.options;
                let builderSessionOne = null;
                builderSessionOne = optionsList.find(
                  (x) =>
                    x && x.label && x.label.toLowerCase() == "buildersessionid"
                );

                let designProjectId = optionsList.find(
                  (x) => x.label == "DESIGN_PROJECT_ID"
                );

                if (builderSessionOne) {
                  let sessionId = builderSessionOne.option_value;
                  if (sessionId) {
                    const sessionData = await doFetchList({ sessionId });
                    if (sessionData && sessionData.length > 0) {
                      let itemId = sessionData.map((a) => a.id);
                      let thumbnailUrl = sessionData.map(
                        (a) => a.thumbnail_url
                      );
                      cartProductList[i]["thumbnail_url"] = thumbnailUrl;
                      cartProductList[i]["session_item_id"] = itemId;
                    }
                  }
                } else if (designProjectId) {
                  let value = designProjectId.option_value;
                  if (value) {
                    console.log("designProjectId", value);
                    try {
                      let response = await doFetchByDesignProjectId({
                        designProjectId: value
                      });
                      let builderSession =
                        response.length > 0 ? response[0] : null;
                      if (builderSession.order_state == "prepare_svg") {
                        if (
                          builderSession &&
                          builderSession.builder_session_item.length > 0
                        ) {
                          let builderSessionItemList =
                            builderSession.builder_session_item.map((item) => ({
                              ...item,
                              thumbnailUrl: null
                            }));

                          cartProductList[i]["builderSessionItemList"] =
                            builderSessionItemList;
                        }

                        dispatch("pollSessionData", {
                          designProjectId: value,
                          index: i
                        });
                      } else {
                        console.log(
                          "builderSession order state change",
                          builderSession.order_state
                        );
                        if (
                          builderSession &&
                          builderSession.builder_session_item.length > 0
                        ) {
                          let builderSessionItemList =
                            builderSession.builder_session_item;
                          cartProductList[i]["builderSessionItemList"] =
                            builderSessionItemList;
                        }
                      }
                    } catch (error) {
                      console.log(
                        "error in fetching design based session fetch",
                        error
                      );
                    }
                  }
                }
              }
            }
          }
          commit("setCartProductDetails", humps(cartProductList));
          commit("setCartProductList", humps(cartProductList));
          commit("cartProductsProgress", false);
          dispatch("productTotalAmt");
          return humps(cartProductList);
        }
        // return true;
      } catch (err) {
        commit("cartProductsProgress", false);
        throw err;
      }
    },
    removeCartProduct: async ({ commit, dispatch, state }, { productId }) => {
      try {
        commit("cartProductsProgress", true);
        let userQuote = state.cartProductDetails[0].id;
        let trueOrFalse = await doDeleteCartProduct(productId, userQuote);
        if (trueOrFalse) {
          commit("cartProductsProgress", false);
          commit("cartTotalAmtProgress", false);
          commit("setCartDrawer", false);
          await dispatch("cartProductList");
          dispatch("setListrakCartListClear");
        }
      } catch (err) {
        commit("cartProductsProgress", false);
        throw err;
      }
    },
    setListrakCartListClear: async ({ commit, state }) => {
      if (state.cartProductList.length <= 0) {
        commit("setListrakCartListClear");
      }
    },
    setCriteoViewBasket: async ({ commit, state }) => {
      if (state.cartProductList.length > 0) {
        commit("setCriteoViewBasket");
      }
    },
    setListrakCartList: async ({ commit, state }) => {
      if (state.cartProductList.length > 0) {
        commit("setListrakCartList");
      }
    },
    updateToCart: async ({ commit, dispatch, state }, data) => {
      try {
        commit("inProgress", true);
        let userQuote = state.cartProductDetails[0].quoteId;
        const cartProduct = await doPutCartItem(
          data.sku,
          data.qty,
          data.price,
          userQuote,
          data.itemId,
          data.personalizeData
        );
        if (cartProduct) {
          commit("inProgress", false);
          //  commit('setCartDrawer', true);
          commit("setCartProduct", cartProduct);
          dispatch("cartProductList");
        }
      } catch (err) {
        dispatch("cartProductList");
        commit("inProgress", false);
        throw err;
      }
    },

    updateMiniCart: async ({ commit, dispatch, state }, data) => {
      try {
        let userQuote = state.cartProductDetails[0].id;
        commit("cartProductsProgress", true);
        const cartProduct = await doPutMiniCartItem(
          data.sku,
          data.qty,
          userQuote,
          data.itemId,
          data.ccid,
          data.price,
          data.personalizeDetails
        );
        if (cartProduct) {
          commit("cartProductsProgress", false);
          // commit('setCartDrawer', true);
          commit("setCartProduct", cartProduct);
          await dispatch("cartProductList");
          return cartProduct;
        }
      } catch (err) {
        await dispatch("cartProductList");
        commit("cartProductsProgress", false);
        throw err;
      }
    },

    updateToPersonalizeCartItem: async (
      { commit, dispatch, state },
      {
        qty,
        itemId,
        perosonalizeIdValue,
        orderTotal = null,
        productOptions,
        byType,
        optionIdType,
        routeName = null,
        updateToCC = false,
        perosonalizeId = null
      }
    ) => {
      try {
        let totalPrice = "" + orderTotal;
        if (updateToCC) {
          let responseData = await doUpdateCCProductQuantity({
            orderNumber: perosonalizeIdValue,
            quantity: qty
          });
          const match = responseData.data.match(/price\s+is:\s*(\d+)/i);
          const price = match ? Number(match[1]) : null;
          totalPrice = "" + price;
        }

        if (!isStrictNonZeroDecimal(totalPrice)) {
          throw "Error in updating cart quntity, please try again later.";
        }

        if (!perosonalizeId) {
          throw "Error in updating cart quntity, please try again later.";
        }

        const customOptions = [
          { name: perosonalizeId, value: perosonalizeIdValue },
          { name: "custom_price", value: totalPrice }
        ];
        const customizableOptions = getProductOptionByType({
          productOptions,
          customOptions,
          action: "update",
          optionIdType: optionIdType,
          byType: byType
        });

        // Update cart item quantity
        const cartProduct = await doQtyUpdateCartItem({
          qty: qty,
          quoteId: state.userQuoteId,
          itemId: itemId,
          customizableOptions: customizableOptions
        });

        if (!cartProduct) return null;

        // UI updates
        if (routeName !== "CartProducts") {
          commit("setCartDrawer", true);
        }
        return cartProduct;
      } catch (err) {
        console.error("update to cart failed:", err);
        throw err;
      }
    },
    updateToConfiguredCart: async ({ commit, dispatch, state }, data) => {
      try {
        commit("cartProductsProgress", true);
        let userQuote = state.cartProductDetails[0].quoteId;
        const cartProduct = await doPutConfiguredCartItem(
          data.sku,
          data.qty,
          userQuote,
          data.itemId,
          data.optionId,
          data.optionValue
        );
        if (cartProduct) {
          //  commit('setCartDrawer', true);
          commit("setCartProduct", cartProduct);
          dispatch("cartProductList");
        }
      } catch (err) {
        dispatch("cartProductList");
        commit("cartProductsProgress", false);
        throw err;
      }
    },
    updateToGiftCart: async ({ commit, dispatch, state }, data) => {
      try {
        commit("inProgress", true);
        data.userQuote = state.cartProductDetails[0].quoteId;
        const cartProduct = await doPutGiftCartItem(
          data,
          state.giftCartDetails
        );
        if (cartProduct) {
          commit("inProgress", false);
          if (data.routeName != "CartProducts") {
            // commit('setCartDrawer', true);
          }
          commit("setCartProduct", cartProduct);
          dispatch("cartProductList");
        }
      } catch (err) {
        await dispatch("cartProductList");
        commit("inProgress", false);
        throw err;
      }
    },
    cartDrawer: async ({ commit }, flag) => {
      commit("setCartDrawer", flag);
    },
    checkUserToken: ({ commit, dispatch }, obj) => {
      let timeInterval = null;
      timeInterval = setInterval(() => {
        if (!getAuthUser()) {
          console.log("setInterval", timeInterval, obj);
          commit("setCartProductList", []);
          commit("setProductAmt", {});
          commit("setAutoLogoutFlag", true);
          dispatch("auth/logout", {}, { root: true });
          clearInterval(timeInterval);
        }
      }, 3000);
    },
    pollSessionData: async (
      { commit },
      { designProjectId, index, interval = 2000, maxTries = 20 }
    ) => {
      let tries = 0;

      const pollInterval = setInterval(async () => {
        try {
          tries++;
          let response = await doFetchByDesignProjectId({
            designProjectId
          });
          let builderSession = response.length > 0 ? response[0] : null;
          console.log("builderSession order state", builderSession.order_state);
          if (builderSession.order_state !== "prepare_svg") {
            console.log(
              "builderSession order state changed",
              builderSession.order_state
            );
            clearInterval(pollInterval);
            if (
              builderSession &&
              builderSession.builder_session_item.length > 0
            ) {
              let builderSessionItemList =
                builderSession.builder_session_item.map((item) => ({
                  ...item,
                  thumbnailUrl: item.thumbnail_url
                }));

              commit("updateCartItem", {
                index: index,
                data: { builderSessionItemList: builderSessionItemList }
              });
            }
          } else if (tries >= maxTries) {
            console.warn(
              "Session data not found after 10 tries, stopping poll."
            );
            clearInterval(pollInterval);
          }
        } catch (err) {
          console.error("Error polling session data:", err);
          clearInterval(pollInterval);
        }
      }, interval);

      return pollInterval; // so you can clear it manually if needed
    }
  }
};
